import React, {FC, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Box, Dialog, Select} from "@scope/scope-one-ui/core";
import {useToasts} from '@scope/scope-one-ui/core/Messages/context';
import {SubscriberConfirmation, SubscriberConfirmations, User} from '../types';
import {setSubscriberConfirmation} from '../services/rsrService';

type SetSubscriberConfirmationProps = {
  user?: User;
  open: boolean;
  onClose: (set: boolean) => void;
};

export const SetSubscriberConfirmationModal: FC<SetSubscriberConfirmationProps> = ({open, onClose, user}) => {
  const {t} = useTranslation();
  const {error, success} = useToasts();

  const [selectedConfirmation, setSelectedConfirmation] = useState<SubscriberConfirmation>(SubscriberConfirmations.BLANK);

  const contractTypes = [
    {value: SubscriberConfirmations.BLANK, label: "-"},
    {value: SubscriberConfirmations.SENT, label: t('ADMIN.RSR.CONFIRMATION_SENT')},
    {value: SubscriberConfirmations.SIGNED, label: t('ADMIN.RSR.CONFIRMATION_SIGNED')},
  ];

  const handleConfirmationChange = (value: string | number | string[]) => {
    setSelectedConfirmation(value as SubscriberConfirmations);
  };

  const setConfirmationHandler = async () => {
    if (user && user.organisationId) {
      try {
        const result = await setSubscriberConfirmation([user.organisationId], selectedConfirmation);
        if (result) {
          success({title: '', content: t('ADMIN.SNACKS.COFIRMATION_SET')});
        }
      } catch (e) {
        error({title: '', content: t('ADMIN.SNACKS.CONFIRMATION_FAILED')});
      }
    } else {
      error({title: '', content: 'User has no organization assigned'})
    }
    onClose(true);
  };

  useEffect(() => {
    setSelectedConfirmation(SubscriberConfirmations.BLANK);
  }, [open]);

  return (<Dialog
      title='Subscriber Confirmation Status'
      open={open}
      onClose={() => onClose(false)}
      confirmLabel='Submit'
      onConfirm={setConfirmationHandler}
    >
      <Box p={3}>
        <Select
          onChange={handleConfirmationChange}
          value={selectedConfirmation || user?.confirmation || SubscriberConfirmations.BLANK}
          options={contractTypes}
        />
      </Box>
    </Dialog>
  );
};
